<tile title="{{ 'top_ranking_keyword' | translate }}" help="{{ 'top_ranking_keyword_help' | translate }}">
  <ng-template tileContent>
    <h2 [style.fontSize]="fontSize" class="align-middle text-muted mt-4"><span class="fa fa-search text-success c-fa"></span>&nbsp;
      <span class="topKeyword" *ngIf="topRankingKeyword">{{topRankingKeyword}}</span>
      <span class="topKeyword" *ngIf="!topRankingKeyword">-</span>
    </h2>
  </ng-template>
</tile>